var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 0H0.5625C0.413316 0 0.270242 0.0592632 0.164752 0.164752C0.0592632 0.270242 0 0.413316 0 0.5625V13.3125C0 13.6606 0.138281 13.9944 0.384422 14.2406C0.630564 14.4867 0.964403 14.625 1.3125 14.625H17.8125C18.1606 14.625 18.4944 14.4867 18.7406 14.2406C18.9867 13.9944 19.125 13.6606 19.125 13.3125V0.5625C19.125 0.413316 19.0657 0.270242 18.9602 0.164752C18.8548 0.0592632 18.7117 0 18.5625 0ZM17.1169 1.125L9.5625 8.04938L2.00812 1.125H17.1169ZM17.8125 13.5H1.3125C1.26277 13.5 1.21508 13.4802 1.17992 13.4451C1.14475 13.4099 1.125 13.3622 1.125 13.3125V1.84125L9.1875 9.22687C9.29119 9.32174 9.42665 9.37435 9.56719 9.37435C9.70773 9.37435 9.84318 9.32174 9.94688 9.22687L18 1.84125V13.3125C18 13.3622 17.9802 13.4099 17.9451 13.4451C17.9099 13.4802 17.8622 13.5 17.8125 13.5Z",
    fill: "#3B9A45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.d7422f1227642fd27b5a21d30c9887f3.svg";
export { ForwardRef as ReactComponent };